export default __webpack_public_path__ + "media/images/table_layouts/email-preview-a15bc4a258b294d2990afe9f0048a8f9.jpeg";